//FILES UTILS

import { Annotation } from '../objects/Annotation.interface';
import { Entity } from '../objects/Entity.interface';
import { Document } from '../objects/Document.interface';
import { Field } from '../objects/Field.interface';
import { Project } from '../objects/Project.interface';

type JoinDataResult = [ string, number[] ];
export const ReadFile = (inputFile:File):any => {
    const temporaryFileReader = new FileReader();
    
    return new Promise((resolve, reject) => {
      temporaryFileReader.onerror = () => {
        temporaryFileReader.abort();
        reject(new DOMException("Problem parsing input file."));
      };

      temporaryFileReader.onload = () => {
        resolve(temporaryFileReader.result as string);
      };
      temporaryFileReader.readAsText(inputFile)//readAsText(inputFile);
    });
};
/**
 * Get title of document to save in browser database
 * @param inputFile 
 * @returns title of document to save
 */
export const getDocumentId = (inputFile:File, documents:Document[]):number => {
    var documentFileName = inputFile.name.replace(".ann.json",".txt");//split tagtog id in document name
    var document = documents.find(doc => doc.title === documentFileName);
    if(document)
      return document.id;//delete extension file
    else
      return -1;
};

/**
 * Get title of annotations document to save in browser database
 * @param inputFile 
 * @returns title of aanotations document to save
 */
 export const getTitleDocument = (inputFile:File):string => {
  return inputFile.name;//delete extension file
};

export const readBinaryContent = (buffer: Uint8Array):string => {
    return  new  TextDecoder('utf-8').decode(buffer);  
  };

export const parseStringToArrayBuffer = (content: string):Uint8Array =>{
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(content); // Encodes the string into a Uint8Array
  return uint8Array;

}

export const convertStringToDOM = (corpusDocument: HTMLElement,content: string, annotationsSelectedList: Annotation[], annotations:Annotation[], entities:Entity[]): string =>{
  var contentFilter = removeSpecialCharacters(content);
  
  var doc = new DOMParser().parseFromString(contentFilter, "text/xml");
  var documentSection = document.createElement("section");
  documentSection.setAttribute("class", 'section-corpus-text');
  
  var paragraphs = removeSpecialCharacters(contentFilter).split('\n').filter(item => item !== '\r');

  paragraphs.forEach((paragraph, index) => {
    var paragraphId = 's1p'+ (index + 1);
    var elementP = doc.createElement("p");
    var annSelectedbyParagraph = annotationsSelectedList.filter(item => item.paragraph === paragraphId);
    var annByParagraph = annotations.filter(item => item.paragraph === paragraphId);
    var annotationsHTML = processHTMLAnnotations(paragraph, annSelectedbyParagraph, annByParagraph, entities);
    elementP.setAttribute("class", 'section-corpus-paragraph' );
    elementP.setAttribute("id", paragraphId);
    elementP.insertAdjacentHTML('beforeend', annotationsHTML);
    documentSection.appendChild(elementP);
  });

  
  return documentSection.outerHTML;
}

export const findNewAnnotationsInText = (selected:Annotation,annotationList: Annotation[], textContent:string, documentId:number,projectId:number, firstEntity:Entity|undefined, secondEntity:Entity|undefined):Annotation[] => {
  
  const textToFound:string =  selected.text;
  var newStartIndex = 0;
  var newEndIndex =  newStartIndex + textToFound.length;
  var newAnnotationList:Annotation[] = [];
  
      var paragraphs = textContent.split('\n').filter(item => item !== '\r');
      paragraphs.forEach((paragraph, index) => {
        let regex_word = new RegExp("(?<![\\w\\d])"+replaceSpecialCharactersForAnnotation(basicFormatString(textToFound))+"(?![\\w\\d])", "gi");
        let procesedTextContent = replaceSpecialCharactersForAnnotation( basicFormatString(paragraph));

        let array1;
        while ((array1 = regex_word.exec(procesedTextContent)) !== null) {

          newStartIndex = regex_word.lastIndex - textToFound.length;
          newEndIndex = newStartIndex + textToFound.length;
            var newAnnotation:Annotation = {
              text: paragraph.substring(newStartIndex,newEndIndex),
              start: newStartIndex,
              end: newEndIndex,
              paragraph: 's1p'+ (index+1),
              documentId: documentId,
              firstEntityId: (firstEntity)?firstEntity.id!:-1,
              secondEntityId: (secondEntity)?secondEntity.id!:-1,
              firstEntityCode: (firstEntity)?firstEntity.Code:'',
              secondEntityCode: (secondEntity)?secondEntity.Code:'',
              fieldsFirstEntity: selected.fieldsFirstEntity,
              fieldsSecondEntity: selected.fieldsSecondEntity,
              isUniqueMode: selected.isUniqueMode,
              status: 'Draft',
              relatedTo: -1,
              relatedText: '',
              relatedKey: ''
            };
            var duplicatedResult = annotationList.find(item => item.start === newAnnotation.start &&
              item.end === newAnnotation.end &&
              item.paragraph === newAnnotation.paragraph &&
              item.text === newAnnotation.text || 
              (
                basicFormatString(item.text).includes(basicFormatString(newAnnotation.text)) &&
                newAnnotation.start >= item.start &&
                newAnnotation.end <= item.end &&
                item.paragraph === newAnnotation.paragraph
              )
              );

            if(duplicatedResult === undefined)
              newAnnotationList.push(newAnnotation);
        }
        newStartIndex = 0;
        newEndIndex =  newStartIndex + textToFound.length;
      });

  return newAnnotationList;
}

export const joinAnnotationsSelected = (currentDocument: Document, markerTextChar:DocumentFragment):JoinDataResult=>{
  var newTextContent : string = '';
  var removedParagraphIds : number [] = [];
  var documentText:string = readBinaryContent(currentDocument.textContent);
  const firstChild = markerTextChar.firstChild;
  const secondChild = markerTextChar.lastChild;

  if (firstChild instanceof HTMLElement && secondChild instanceof HTMLElement) {
    const firstParagraphId = parseInt(firstChild.getAttribute('id')!.split('p')[1]) - 1;
    const secondParagraphId = parseInt(secondChild.getAttribute('id')!.split('p')[1]) - 1;
    
    var paragraphs = documentText.split('\n').filter(item => item !== '\r');

    if(firstParagraphId <= paragraphs.length)
    {
      var firstNewParagraph = paragraphs[firstParagraphId].replace('\r','') + secondChild!.textContent!;
      paragraphs.forEach((paragraph, index) => {
        
          if(index === secondParagraphId){
            const secondChildTextContentLength = secondChild!.textContent!.length;
            if(secondChildTextContentLength === paragraph.replace('\r','').length)
            {
              removedParagraphIds.push(secondParagraphId);
            }else
            {
              newTextContent = newTextContent + paragraph.substring(secondChildTextContentLength,paragraph.length)+'\n';
            }

          }
          else if(index !== firstParagraphId)
          {
            newTextContent = newTextContent + paragraph + '\n';
          }
          else{
            newTextContent =  newTextContent + firstNewParagraph + '\n';
          }
  
      });
    }
    
  }

  return [newTextContent, removedParagraphIds];
}

export const updateIndexAnnotationsByJoin = (annotations:Annotation[],markerTextChar: DocumentFragment, secondParagraphId: string|null, updatedAnnotations:Annotation[] )=>{
  var secondTextSelectedLength = 0;
  //filtrar para obtener solo las anotaciones existentes del segundo parrafo escogido
  var annotationsFiltered = annotations.filter(item => item.paragraph === secondParagraphId);
  if(markerTextChar.textContent?.includes('\n'))
    secondTextSelectedLength = markerTextChar.textContent!.split('\n')[1].length;
  else if( markerTextChar.lastChild instanceof HTMLElement){
    secondTextSelectedLength = markerTextChar.lastChild!.textContent!.length;
  }
  annotationsFiltered.forEach(annotation =>{ 
      annotation.start = annotation.start - secondTextSelectedLength;
      annotation.end =annotation.end - secondTextSelectedLength
      updatedAnnotations.push(annotation);

  });
}

export const updateParagraphAnnotationsByJoin = (annotations: Annotation[], paragraphRemovedNumber: number, updatedAnnotations:Annotation[])=>
{
  var annotationsFiltered = annotations.filter(item => parseInt(item.paragraph.split('p')[1]) >= paragraphRemovedNumber);
  annotationsFiltered.forEach(annotation =>{ 
    var newParagraph = parseInt(annotation.paragraph.split('p')[1]) - 1 ;
    annotation.paragraph = 's1p'+(newParagraph) ;
    updatedAnnotations.push(annotation);
  });

}


const processHTMLAnnotations = (content:string, annotationsSelected:Annotation[], annotationsSaved:Annotation[], entities:Entity[]):string => {
  
  
  var ContentAnnotations:string = content;

  var paragraphWithAnnotations:string = '';
  let annotations: Annotation[] = [];
  annotations = annotations.concat(annotationsSelected);
  annotations = annotations.concat(annotationsSaved);

  annotations.sort((a,b) => (a.start < b.start ? -1 : 1));
  if(annotations.length > 0)
  {
    var lastIndex=-1;
    for(var start= annotations.length-1; start >= 0 ; start--){
    
      if(lastIndex !== annotations[start].start)
      {
        let firstEntityId:number = annotations[start].firstEntityId;
        let secondEntityId:number = annotations[start].secondEntityId;

        if(lastIndex === -1)
          paragraphWithAnnotations = buildTextAnnotated(ContentAnnotations.substring(annotations[start].start,ContentAnnotations.length), annotations[start], getAnnotationColor(entities, firstEntityId, firstEntityId), getAnnotationColor(entities, secondEntityId, firstEntityId), entities) + paragraphWithAnnotations;
        else
        paragraphWithAnnotations = buildTextAnnotated(ContentAnnotations.substring(annotations[start].start,lastIndex),annotations[start],getAnnotationColor(entities, firstEntityId, firstEntityId), getAnnotationColor(entities, secondEntityId, firstEntityId), entities) + paragraphWithAnnotations;
  
        lastIndex = annotations[start].start;
      }
    
    }

    if(lastIndex !== 0)
      paragraphWithAnnotations = ContentAnnotations.substring(0, lastIndex)+ paragraphWithAnnotations;
    
    return paragraphWithAnnotations;
  }
  else
    return ContentAnnotations;
}

/*
export const buildNamespaceList = (entities: Entity[]): Namespace[] =>{
  var namespaceList: Namespace[] = [];
  type uniqueArr = Set<string>;
  var namespaceValues: uniqueArr =new Set(entities.map(item => item.Namespace));
  namespaceValues.forEach(namespaceItem => {

    var newNamespace: Namespace ={
      name: namespaceItem,
      entities: entities.filter(item => item.Namespace === namespaceItem)
    }
    
    namespaceList.push(newNamespace);
  });
  return namespaceList;
}
*/

const buildTextAnnotated = (paragraphContent: string, annotation: Annotation, firstColor:string, secondColor:string, entities:Entity[]): string=>{
 

  const annotationText = paragraphContent.substring(0, annotation.text.length);
  const restText = paragraphContent.substring(annotation.text.length, paragraphContent.length);
  
  var elementContent = document.createElement("span");
  elementContent.setAttribute("class","annotated-content");
  if(annotation.status === 'Saved')
    elementContent.setAttribute("style","color: #1c1c1c; background: linear-gradient(90deg, "+firstColor+" 0%, "+firstColor+" 50%, "+secondColor+" 50%, "+secondColor+" 50%); ");
  else if (annotation.status === 'Draft')
    elementContent.setAttribute("style", "background-color: #1b96f1; color: white;");
  else
    elementContent.setAttribute("style", "background-color: #1b96f1; color: white;");

  var annotationId = (annotation.id)?annotation.id!.toString():'tmp'+Math.random().toString()
  elementContent.setAttribute("id",annotationId);
  elementContent.setAttribute("annotationId",annotationId)
  elementContent.setAttribute("keywords", annotation.text);
  elementContent.innerText = annotationText;

  return elementContent.outerHTML + restText;
}

const getAnnotationColor =(entities: Entity[], entityId: number, secondEntityId:number|null):string =>{
  
  var entityColor: string = '';
  var entity = entities.find(entity => entity.id! === entityId);

  if(!entity){
    var secondEntity = entities.find(entity => entity.id! === secondEntityId);
    if(secondEntity)
      entityColor = secondEntity.Color;
    else
      entityColor = "hsl(0, 0%, 19%)";
  }
  else
    entityColor = entity.Color!;

  return entityColor;
}

export const removeAccents = (str: string) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
} 

export const basicFormatString = (str:string) =>{
    return str.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const removeBreakLine = (str: string):string => {
  str = str.replace("\n", "");
  str = str.replace("\r", "");
  return str;
}


export const removeSpecialCharacters =(str: string): string =>
{
    str = str.replace(/[&<>]/g, " ");
    str = str.replaceAll("/p", "  ");
    str = str.replaceAll("\f", " ");
    return str;
}

/**
 * 
 * @param str Remove non printable characters 
 * @returns new text without non printable character \u00A0 - NO-BREAK SPACE
 */
export const removeNonPrintableCharacters =(str: string):string =>{

  return str.replace(/[\u00A0]/g, " ");

}

/**
 * @param str Method to replace caracters '()[]' that break search processs in text
 * @returns return text with characters replaced by ' character
 */
export const replaceSpecialCharactersForAnnotation = (str: string): string =>
{
    str = str.replace(/[()[\]]/g,"'");

    return str;
}

export const hslToHex = (h:number, s:number, l:number): string => {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export const getEntityCode = (list:Entity[], project:Project): string =>
{
  var code = "e_";

  if(list.length > 0)
  {
    var listCodeInteger: number[] = [];
    var listCode = list.map(entity  => entity.Code);
    
    listCode.forEach(code => {
      var integerCode = parseInt(code.replace("e_","").split(".")[0]);
      if(integerCode !== undefined)
        listCodeInteger.push(integerCode);
    });

    const higherNumber = getHigherNumber(listCodeInteger);
    code = code + higherNumber.toString();
  }else
  {
    code = "e_1";
  }
  return code;
}

export const getFieldCode = (list:Field[]|undefined, entityCode:string): string =>
{
  var code = "f_";
  var entityIdNumber = entityCode.split('_')[1];

  if(list !== undefined && list.length > 0)
  {
    var listCodeInteger: number[] = [];
    var listCode = list.map(field  => field.code);
    
    listCode.forEach(code => {
      var integerCode = parseInt(code.replace("f_",""));
      if(integerCode !== undefined && !isNaN(integerCode) )
        listCodeInteger.push(integerCode);
    });

    const higherNumber = getHigherNumber(listCodeInteger)
    code = code+entityIdNumber+ higherNumber.toString();
  }else
  {
    code = 'f_'+entityIdNumber+'1';
  }
  return code;
}

export const getHigherNumber = (values:number[]):number =>
{
  if(values.length > 0)
    return  values.reduce((prev, cur) => (cur > prev ? cur : prev))+1;
  else
    return 1;
}

export const buildTagTogFieldsJSON = (entity:Entity,fieldsCode:string[],replacer:any):any=>{

  var fieldsToAdd: Field[] = getFields(entity, fieldsCode);
  return JSON.parse(createJSONFields(fieldsToAdd, replacer));
}

export const getFields = (entity:Entity, fieldsCode: string[]):Field[]=>{
  var fieldsText:Field[]=[];
 
      fieldsCode.forEach(item=>{
          if(entity.FieldList !== undefined){
              var fieldObject = entity.FieldList.find(field => field.code === item);
              if(fieldObject !== undefined)
              {
                  fieldsText.push(fieldObject);
              }
          }
      });

  
  return fieldsText;
}

const  createJSONFields =(fields:Field[], replacer:any):string=>{
  var fieldsValues: string = '{ ';

  fields.forEach(field => {
    fieldsValues += ' "'+field.code + '" : { "value" : "'+field.name+'"} ,' ;

  });
  fieldsValues = fieldsValues.substring(0,fieldsValues.length-1);
  fieldsValues += ' }';
  return JSON.stringify(fieldsValues, replacer);
}

export const getDuplicateUniquesAnnotations = (annotationsToSave:Annotation[],annotationSelected:Annotation):Annotation[]=>{
  var annotationsToUpdate = annotationsToSave.filter(item => item.text === annotationSelected.text && item.start === annotationSelected.start && item.end === annotationSelected.end && item.paragraph === annotationSelected.paragraph);

  return annotationsToUpdate;
}

export const removeRelatedAnnotationsKeepOne =(annotations:Annotation[]):Annotation[]=>{
  const relatedAnnotations = annotations.filter(item => item.relatedTo !== -1);
  var relatedAnnotationIds:number[] = [];
  var result = relatedAnnotations.map(item =>{

    relatedAnnotationIds.push(item.relatedTo);
    return ({
      id: item.id,
      relatedId: item.relatedTo,
      remove: (relatedAnnotationIds.includes(item.id!))?true:false
    });

  });

  var annotationToRemoveFromCounter = result.filter(item => item.remove === true).map(item => item.id);
  return annotations.filter(annotation => !annotationToRemoveFromCounter.includes(annotation.id) );
}